import API from "../api/api";

export class DistributorService {
  async getDistributorById(distributorId: string) {
    const resposne = await API.get(`/distributor/${distributorId}`);
    return resposne.data;
  }

  // Distributor-scoped config (currency, partner name, branding).
  // Token-driven on the new backend — partner is inferred from the scoped JWT.
  async getPartnerConfig() {
    const response = await API.get(`/distributor-dashboard/partner-config`);
    return response.data;
  }

  async sendFeedback(feedback: any) {
    await API.post(`/merchantDashboard/feedback`, feedback);
  }
}
